import React, { useEffect, useState } from 'react'

import Axios from 'axios'

import TeamSquadList from './TeamTemplates/TeamSquadList'
import { firestore } from '../../../../firebase'
import TeamPlayersFB from './TeamTemplates/TeamPlayersFB'

function TeamSquad(props) {
    const [activeItem, setActiveItem] = useState('1')

    const [squad, setSquad] = useState()

    const [keepers, setKeepers] = useState()
    const [defenders, setDefenders] = useState()
    const [midfielders, setMidfielders] = useState()
    const [attackers, setAttackers] = useState()

    const [isLoading, setIsLoading] = useState(true)

    const [playersFB, setPlayersFB] = useState([])

    useEffect(() => {
        try {
            const playersRef = firestore.collection('team-players')

            playersRef
                .where('team_id', '==', props.id)
                .onSnapshot(({ docs }) => {
                    const players = docs.map((doc) => {
                        return { id: doc.id, ...doc.data() }
                    })
                    setPlayersFB(players)
                })
        } catch (error) {}
    }, [props.id])

    useEffect(() => {
        async function fetchSquad() {
            setIsLoading(true)

            try {
                const response = await Axios({
                    method: 'GET',
                    url:
                        'https://api-football-v1.p.rapidapi.com/v2/players/squad/' +
                        props.id +
                        '/2020-2021',
                    headers: {
                        'content-type': 'application/octet-stream',
                        'x-rapidapi-host': 'api-football-v1.p.rapidapi.com',
                        'x-rapidapi-key':
                            '4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45',
                        useQueryString: true,
                    },
                })
                if (response.data) {
                    setSquad(response.data.api.players)
                    console.log(response.data.api.players)
                    const keepers = response.data.api.players.filter(
                        (player) => {
                            return player.position === 'Goalkeeper'
                        }
                    )
                    setKeepers(keepers)
                    const defenders = response.data.api.players.filter(
                        (player) => {
                            return player.position === 'Defender'
                        }
                    )
                    setDefenders(defenders)
                    const midfielders = response.data.api.players.filter(
                        (player) => {
                            return player.position === 'Midfielder'
                        }
                    )
                    setMidfielders(midfielders)
                    const attackers = response.data.api.players.filter(
                        (player) => {
                            return player.position === 'Attacker'
                        }
                    )
                    setAttackers(attackers)
                }
                //console.log(response.data.api.players)
            } catch (error) {
                console.log(error)
            }

            setIsLoading(false)
        }
        fetchSquad()
    }, [])

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    if (isLoading) return <p>Laster spillere...</p>

    return (
        <div>
            <div className="row no-gutters">
                <div className="col-6">
                    <button
                        className={`btn btn-block btn-primary ${
                            activeItem === '1' && 'active'
                        }`}
                        onClick={() => toggle('1')}
                    >
                        Liste
                    </button>
                </div>
                <div className="col-6">
                    <button
                        className={`btn btn-block btn-primary ${
                            activeItem === '2' && 'active'
                        }`}
                        onClick={() => toggle('2')}
                    >
                        Galleri
                    </button>
                </div>
            </div>

            {activeItem === '1' && (
                <TeamSquadList
                    keepers={keepers}
                    defenders={defenders}
                    midfielders={midfielders}
                    attackers={attackers}
                />
            )}
            {activeItem === '2' && (
                <TeamPlayersFB teamId={props.id} playersAPI={squad} />
            )}
        </div>
    )
}
export default TeamSquad
